// extracted by mini-css-extract-plugin
module.exports = {"root":"_2WLXB","list":"_1L7m6"};